import { ApiPath } from "enums";
import { Get } from "utils";

export const getWallet = async ({ fleetId, ...query }) => {
  const res = await Get(`${ApiPath.Wallet}/fleet/${fleetId}`, query);
  return res.data;
};
